{
  "new": {
    "title": "Contract configuration",
    "tabs": {
      "add": "Add Contract Template",
      "generate": "Generation",
      "management": "Management",
      "signing": "Signing"
    }
  },
  "infos": {
    "generated_contract": "Generated contracts"
  },
  "add_contract": {
    "contract": "Contract",
    "generate": "Generate"
  },
  "deposit": {
    "title": "Deposit",
    "tabs": {
      "idahe2": "IDAHE 2",
      "eps": "EPS"
    },
    "modal": {
      "title": "Event in progress",
      "caution": "Caution: ",
      "warning_text_deposit": "there are no deposits that are not yet validated. | there is {n} deposit that is not yet validated: | there are {n} deposits that are not yet validated:",
      "warning_text_contract": "there are no contracts that are not yet signed. | there is {n} contract that is not yet signed: | there are {n} contracts that are not yet signed:",
      "description": "Contract management and submissions will no longer be accessible. Would you like to set the event to in progress stage?",
      "button": "Set the event to in progress stage"
    },
    "floating_action_bar": {
      "buttons": {
        "send_to_bot": "Initialize the deposit",
        "create_manual_submission": "Send manually"
      }
    }
  },
  "deposit_info": {
    "title": "Deposit information"
  },
  "management_contract": {
    "sign_status": "Signing Status",
    "deposit_status": "Deposit Status",
    "upload_document": "Upload your document",
    "joint_file": "Specify the type of joint file",
    "add_a_file": "Add a file to",
    "signed_at": "Signature date of the signed contract",
    "regime": "Regime",
    "sign": "Sign",
    "deposit": "Deposit",
    "reminder": "Reminder",
    "event_in_progress": "Event in progress stage",
    "custom_type_name": "File name",
    "buttons": {
      "sign_all": "Sign all",
      "remind_all": "Send reminder to all",
      "download_contracts_zip": "Download contracts zip"
    },
    "documents": {
      "SIGNED_CONTRACT": "Signed contract/Signed hospitality convention",
      "CONTRACT": "Contract",
      "ORDER_RESPONSE": "Order response",
      "ACTIVITY_AUTHORIZATION": "Activity cumulation authorization",
      "DIRECTOR_AUTHORIZATION": "Director authorization",
      "RECEIPT": "Receipt",
      "SOLICITATION_LETTER": "Solicitation letter",
      "STATUS": "Status",
      "RIB": "Rib",
      "OFFICIAL_JOURNAL": "Official journal",
      "AMENDMENT_CONTRACT": "Contract amendment",
      "WORK_CERTIFICATE": "Work certificate",
      "DEAN_AUTHORIZATION": "Dean authorization",
      "OTHER": "Other"
    },
    "download_contracts_zip": {
      "modal": {
        "title": "Download format",
        "unsigned_pdf": {
          "title": "Pdf - Unsigned contracts :",
          "description": "Consulted document version. Download your file in pdf format."
        },
        "unsigned_docx": {
          "title": "Docx - Unsigned contracts :",
          "description": "Consulted document version. Download your file in docx format. (Warning, pdf files will not be converted to docx)"
        },
        "signed_pdf": {
          "title": "PDF - Signed contracts :",
          "description": "Download a zip of signed contracts in PDF format"
        },
        "no_generated_template": "No file generated",
        "generated_at": "File generated at: ",
        "button": {
          "validate": "Validate",
          "download": "Download"
        }
      }
    },
    "modal": {
      "shared": {
        "legend": {
          "attendees": "attendee(s)",
          "internes": "internal(s)"
        },
        "link_signers": "Link signers to the contract",
        "select_internal_signer": "Please select an internal signer.",
        "selected_contract": "You have selected the following contract:"
      },
      "ORDERED": {
        "title": "sequential signature",
        "subtitle": "Please select at least one internal signer.",
        "signers_orders": "The signers will be sent with the following order:",
        "signers_orders_multiple_attendee": "The internal signers will be sent with the following order:",
        "multiple_attendee_selected": "The attendees will sign after the internal signers."
      },
      "TRIPARTITE_UNORDERED": {
        "title": "tripartite parallel signature",
        "subtitle": "Please select the internal signer of the contract",
        "signers_orders": "All internal signers will receive the contract at the same time."
      },
      "TRIPARTITE_ORDERED": {
        "title": "tripartite sequential signature",
        "subtitle": "Please select the internal signer of the contract",
        "signers_orders": "The signers will be sent with the following order:"
      },
      "UNORDERED": {
        "title": "parallel signature",
        "subtitle": "Please select the internal signer of the contract (optional)",
        "signers_orders": "The signers will be sent with the following order:",
        "without_internal_signer": "Continue without internal signer"
      },
      "signature": {
        "selected_contract": "You have selected the following contract:",
        "no_contracts_selected": "No contracts selected.",
        "title": "Signature",
        "subtitle": "Please select the internal signer of the document",
        "confirm": "Are you sure you want to send the contract for signature?",
        "sended_to": "The contracts will be sent for signature to:",
        "forwarded_to": "The contracts will be sent for information to:",
        "sended": "Signature request sent. You will receive an email to notify the signature."
      },
      "deposit": {
        "deposit_type": "1. Enter the submission type:",
        "deposit_platform": "2. Select your submission platform:",
        "statement": "Declaration",
        "authorization": "Authorization"
      },
      "delete_contract": {
        "title": "Delete a contract",
        "text": "Deleting this contract of this attendee will cancel the signing procedure. Do you want to proceed?",
        "button": "Delete the contract"
      },
      "delete_attendee": {
        "title": "Delete an attendee",
        "text": "This attendee has a generated contract, deleting the attendee will cancel the signature procedure. Do you want to proceed?",
        "button": "Delete the attendee"
      },
      "reminder": {
        "title": "Reminder",
        "confirm": "Do you confirm sending reminders?",
        "sended_to": "Reminders will be sent to:",
        "sended": "Reminders sent."
      },
      "error_send": {
        "title": "Signing procedure",
        "text": "The signing procedure is in progress.",
        "cancel": "Cancel the signing procedure"
      }
    },
    "badge": {
      "sign_status": {
        "CREATING": "To send",
        "PENDING": "Sent for signing",
        "DONE": "Signed",
        "SIGNING": "Signing in progress",
        "NOT_SENT": "Not sent",
        "NOT_SIGNED": "Not signed",
        "CANCELED": "Canceled"
      },
      "deposit_status": {
        "CREATING": "-",
        "PENDING": "Submission in progress",
        "DONE": "Approved"
      },
      "null": "-",
      "creating": "To sign",
      "filling": "Submission in progress",
      "signing": "Signing in progress",
      "validated": "Approved",
      "signed": "Signed",
      "not_signed": "Not signed",
      "manually": "Manually"
    },
    "table": {
      "header": {
        "identity": "Identity",
        "coordinates": "Address",
        "contract": "Contract",
        "signature_request_type": "Signature request type",
        "attachments": "Attached files",
        "alert": "Alert",
        "signature": "Signature",
        "packages": "Advantages packages"
      }
    },
    "slide_over": {
      "title": "Add a contract"
    }
  },
  "attendee_contract": {
    "document_preview": {
      "save": "Save contract",
      "download": "Download contract",
      "delete": "Delete contract"
    }
  },
  "upload_contract_template": {
    "drag_and_drop_statement": "Please select a file or drag 'n drop it here",
    "or_statement": "Only .DOCX files",
    "cta_label": "Select a file",
    "document_name": "Contract Template name",
    "download": "Download Contract Template",
    "uploaded_contract": "Contract Template added"
  },
  "toast": {
    "generation_failed": "Zip file's generation has failed"
  },
  "popup_modal_mass_delete": {
    "button": "Delete contracts",
    "title": "Confirm deletion",
    "warning": "Are you sure you want to delete the unsigned contracts of the selected attendee? | Are you sure you want to delete the unsigned contracts of the {count} selected attendees?",
    "validate": "Confirm deletion"
  }
}
